import { SET_MOBILE_STATE } from "app/action_types/is_user_on_mobile_device_action_types";

interface IsMobileState {
    isUserOnMobileDevice: boolean;
}

const DEFAULT_STATE: IsMobileState = {
    isUserOnMobileDevice: false,
};

const isUserOnMobileDeviceReducer = (state = DEFAULT_STATE, action: FixmeType): IsMobileState => {
    switch (action.type) {
        case SET_MOBILE_STATE:
            return {
                ...state,
                isUserOnMobileDevice: action.isMobile,
            };
        default:
            return state;
    }
};

export default isUserOnMobileDeviceReducer;
